var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useCallback, useEffect, useMemo, useRef, } from "react";
import { Pane, Button, MenuSection, Checkbox, MessageBanner, } from "@folio/stripes/components";
import { useIntl, FormattedMessage } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import NavComponent from "../NavComponent";
import TableComponent from "../TableComponent";
import { RecekPaneSet } from "../RecekPaneSet";
import { RowClickBoundary } from "../RowClickBoundary";
import { createStripesSource } from "../../utils/createStripesSource";
import { formatLibraryName } from "../../utils/formatUtils";
import { hasHttpResponse } from "../../utils/apiUtils";
import { useTitlesIsbnData } from "../../hooks/useTitlesIsbnData";
import { useTitlesIsbnTable } from "../../hooks/useTitlesIsbnTable";
import { useTitleSort } from "../../hooks/useTitleSort";
import { useListErrorMessage } from "../../hooks/useListErrorMessage";
import { columnSortKeys } from "../../utils/titleSort";
import { useTitleWithIsbnFilters } from "../../hooks/useTitleWithIsbnFilters";
import { TitleWithIsbnFilters } from "../TitleWithIsbnFilters";
import { usePublishersData } from "../../hooks/usePublishersData";
import { useCanRequestCopies } from "../../hooks/useCanRequestCopies";
import { usePermissions } from "../../hooks/usePermissions";
import { useTitleEnforcementActions } from "../../hooks/useTitleEnforcementActions";
import { ScanBar } from "../enforcement/ScanBar";
import { AgencyTitleConfirmDialog } from "../enforcement/AgencyTitleConfirmDialog";
import { TitleDetailPane } from "./TitleDetailPane";
import { ProvisionalTitleModal, } from "./ProvisionalTitleModal";
import { fetchTitleById } from "../../api/titleService";
import { SendEnforcementDialog } from "../enforcement/SendEnforcementDialog";
import { ExcludeDialog } from "../enforcement/ExcludeDialog";
import { AddExtraCopyDialog } from "../enforcement/AddExtraCopyDialog";
import { ReinstateDialog } from "../enforcement/ReinstateDialog";
import { useServerErrorMessage } from "../../hooks/useServerErrorMessage";
import { LinkToPeriodicalDialog } from "../agenda/LinkToPeriodicalDialog";
import { TitleAgendaDialog } from "../agenda/TitleAgendaDialog";
import { SkippedHandledElsewhere } from "../agenda/SkippedHandledElsewhere";
import { handledElsewhere, skippedHandledElsewhereOf, } from "../../utils/agendaLabel";
import { PreLitigationDialog } from "../enforcement/PreLitigationDialog";
import { addExtraCopy, fetchDepositRecordsByTitle, receiveDeposit, receiveByIsbn, receiveExtraCopy, confirmAgencyTitle, reportDamaged, requestCopy, previewRequestCopy, excludeTitle, excludeByTitles, reinstateTitle, reinstateByTitles, createUrgence, createUrgenceByTitles, createUrgenceByPublisher, previewUrgence, previewUrgenceByTitles, previewUrgenceByPublisher, previewDamagedClaimByTitles, sendDamagedClaimByTitles, previewRequestCopyByTitles, requestCopyByTitles, previewExcludeByTitles, } from "../../api/enforcementService";
import { ScanDuplicateTitlesDialog } from "../enforcement/ScanDuplicateTitlesDialog";
import { TitleMergeDialogs } from "./merge/TitleMergeDialogs";
import { MergeResultCallout } from "./merge/MergeResultCallout";
import { readMergeError } from "../../utils/titleMergeErrors";
import { PendingVerificationDialog } from "../enforcement/PendingVerificationDialog";
import { ROUTE_PATHS } from "../../types/routePaths";
import { EXTRA_COPY_REASONS, } from "../../types/enforcement";
import { toTitleInfo } from "../../types/TitleSearch";
import { MAX_MERGE_SET_SIZE, MIN_MERGE_SET_SIZE } from "../../types/titleMerge";
import { CrossLibraryHistoryModal } from "./CrossLibraryHistoryModal";
import { LibraryNoteDialog } from "./LibraryNoteDialog";
import { DEFAULT_VOLUME_STATUSES, VOLUME_STATUS, expandEnforcementTypes, } from "../../utils/volumeConstants";
import { useSelection } from "../../hooks/useSelection";
import { SelectAllBanner } from "../selection/SelectAllBanner";
import { MAX_SELECTION_SIZE, } from "../../types/selection";
import { buildEnforcementSelection } from "../../utils/buildTitleSelection";
import { formatCountSubtitle } from "../../utils/paneCount";
import styles from "./TitleEnforcementList.module.css";
import { describeSendResult, readUrgenceErrorCode, summarizeSkippedRecords, } from "../../utils/urgenceSkipSummary";
import { invalidateDepositRecordViews } from "../../utils/depositRecordQueries";
import { VARIANT_TITLES_COLUMN_WIDTH } from "../../hooks/useVariantTitlesColumn";
import { readErrorCode } from "../../utils/errorHandler";
import { ErrorType } from "../../types/ErrorType";
import { isIssueUnitKey, unitKey } from "../../utils/monographUnit";
import { useIssueAgenda, useTitleAgenda } from "../../hooks/useAgenda";
import { useIsNationalLibrary } from "../../hooks/useIsNationalLibrary";
import { ChangeAgendaDialog, } from "../agenda/ChangeAgendaDialog";
import { AGENDA_STATE_LIST_ERRORS, } from "../../types/agenda";
var VOLUME_TO_DEPOSIT = Object.entries(VOLUME_STATUS).reduce(function (acc, _a) {
    var _b;
    var depositStatus = _a[0], volumeStatus = _a[1];
    ((_b = acc[volumeStatus]) !== null && _b !== void 0 ? _b : (acc[volumeStatus] = [])).push(depositStatus);
    return acc;
}, {});
var expandVolumeStatuses = function (volumeStatuses) {
    return volumeStatuses.flatMap(function (volumeStatus) { var _a; return (_a = VOLUME_TO_DEPOSIT[volumeStatus]) !== null && _a !== void 0 ? _a : []; });
};
var COLUMN_WIDTHS_WITH_ISBN = {
    select: "36px",
    mainTitle: "20%",
    partNumber: "5%",
    partName: "7%",
    variantTitles: VARIANT_TITLES_COLUMN_WIDTH,
    firstContributor: "12%",
    publisher: "12%",
    publicationYear: "7%",
    editionStatement: "9%",
    // Weights of the visible columns only; "Vazba/formát" cannot wrap, so it needs room for its text and sort icon.
    bindingText: "14%",
    depositStatuses: "18%",
    isbn: "13%",
};
var COLUMN_WIDTHS_WITHOUT_ISBN = {
    select: "36px",
    mainTitle: "24%",
    partNumber: "6%",
    partName: "9%",
    variantTitles: VARIANT_TITLES_COLUMN_WIDTH,
    firstContributor: "15%",
    publisher: "15%",
    publicationYear: "7%",
    editionStatement: "9%",
    // Weights of the visible columns only; "Vazba/formát" cannot wrap, so it needs room for its text and sort icon.
    bindingText: "14%",
    depositStatuses: "18%",
};
// codes a monograph-list action may hit since rows follow the library's agenda (DB-196)
var AGENDA_ERROR_CODES = new Set([
    ErrorType.NOT_IN_MONOGRAPH_AGENDA,
    ErrorType.REQUEST_COPY_ISSUE_NOT_SUPPORTED,
    ErrorType.EXTRA_COPY_NOT_IN_MONOGRAPH_AGENDA,
    ErrorType.ACTIVE_LIBRARY_LOOKUP_FAILED,
    ErrorType.NO_ACTIVE_LIBRARY,
    ErrorType.AGENDA_STATE_REQUIRES_LIBRARY,
]);
var EMPTY_DEPOSIT_RECORDS = [];
var EXTRA_COPY_ERROR_IDS = {
    EXTRA_COPY_RECEIPT_NOT_ALLOWED: "ui-br-legaldeposits.enforcement.scan.extraCopyNotAllowed",
    TITLE_NOT_IN_ISBN_MATCHES: "ui-br-legaldeposits.titleMerge.scan.titleNoLongerMatches",
};
export var TitleEnforcementList = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    var withIsbn = _a.withIsbn;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var history = useHistory();
    var canRequestCopies = useCanRequestCopies().canRequestCopies;
    var _3 = usePermissions(), canVerifyTitleItem = _3.canVerifyTitleItem, canMergeTitles = _3.canMergeTitles, canLinkSpecialIssues = _3.canLinkSpecialIssues;
    var volumeStatuses = useMemo(function () {
        return canRequestCopies
            ? DEFAULT_VOLUME_STATUSES
            : DEFAULT_VOLUME_STATUSES.filter(function (s) { return s !== "requested"; });
    }, [canRequestCopies]);
    var queryClient = useQueryClient();
    var _4 = useState(true), filterPaneIsVisible = _4[0], setFilterPaneIsVisible = _4[1];
    var _5 = useTitleEnforcementActions(), selectedTitle = _5.selectedTitle, handleSelectTitle = _5.handleSelectTitle, handleCloseSelectedTitle = _5.handleCloseSelectedTitle;
    var _6 = useState(new Set()), selectedForUrgence = _6[0], setSelectedForUrgence = _6[1];
    var _7 = useState(false), showSendDialog = _7[0], setShowSendDialog = _7[1];
    var _8 = useState(false), showExcludeDialog = _8[0], setShowExcludeDialog = _8[1];
    var _9 = useState(false), showExtraCopyDialog = _9[0], setShowExtraCopyDialog = _9[1];
    var _10 = useState(false), showReinstateDialog = _10[0], setShowReinstateDialog = _10[1];
    var _11 = useState(new Set()), expandedEnforcementRecordIds = _11[0], setExpandedEnforcementRecordIds = _11[1];
    var _12 = useState(null), bulkUrgenceMode = _12[0], setBulkUrgenceMode = _12[1];
    var _13 = useState(false), crossLibraryOpen = _13[0], setCrossLibraryOpen = _13[1];
    var _14 = useState(false), libraryNoteDialogOpen = _14[0], setLibraryNoteDialogOpen = _14[1];
    var _15 = useState(null), bulkErrorMessage = _15[0], setBulkErrorMessage = _15[1];
    var _16 = useState(null), skippedSummary = _16[0], setSkippedSummary = _16[1];
    var _17 = useState(0), executedSkippedHandledElsewhere = _17[0], setExecutedSkippedHandledElsewhere = _17[1];
    var dismissExecutedSkipped = useCallback(function () { return setExecutedSkippedHandledElsewhere(0); }, []);
    var _18 = useState(null), sendResultMessage = _18[0], setSendResultMessage = _18[1];
    var _19 = useState(null), sendRecordIds = _19[0], setSendRecordIds = _19[1];
    var _20 = useState(false), provisionalEditOpen = _20[0], setProvisionalEditOpen = _20[1];
    var _21 = useState(false), showPreLitigationDialog = _21[0], setShowPreLitigationDialog = _21[1];
    var scanBarRef = useRef(null);
    var _22 = useState(null), agencyConfirm = _22[0], setAgencyConfirm = _22[1];
    var _23 = useState(null), pendingVerification = _23[0], setPendingVerification = _23[1];
    var _24 = useState(null), provisionalScanIsbn = _24[0], setProvisionalScanIsbn = _24[1];
    var _25 = useState(false), provisionalCreateOpen = _25[0], setProvisionalCreateOpen = _25[1];
    var _26 = useState(null), scanDuplicates = _26[0], setScanDuplicates = _26[1];
    var _27 = useState(null), extraCopyScan = _27[0], setExtraCopyScan = _27[1];
    var _28 = useState(null), mergeRequest = _28[0], setMergeRequest = _28[1];
    var _29 = useState(null), mergeFromScanIsbn = _29[0], setMergeFromScanIsbn = _29[1];
    var _30 = useState(null), mergeCompletion = _30[0], setMergeCompletion = _30[1];
    var _31 = useState(null), agendaDialogMode = _31[0], setAgendaDialogMode = _31[1];
    var _32 = useState(null), agendaResult = _32[0], setAgendaResult = _32[1];
    var _33 = useState(false), linkPeriodicalOpen = _33[0], setLinkPeriodicalOpen = _33[1];
    var _34 = useState(false), agendaOverviewOpen = _34[0], setAgendaOverviewOpen = _34[1];
    var provisionalTitleQuery = useQuery(["title", selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id], function () {
        return fetchTitleById(kyInstance, selectedTitle.id);
    }, { enabled: !!(selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id) && !!(selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.provisional) });
    var provisionalEditInitialValues = useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var detail = provisionalTitleQuery.data;
        if (!(detail === null || detail === void 0 ? void 0 : detail.provisional))
            return undefined;
        return {
            name: (_a = detail.title) !== null && _a !== void 0 ? _a : "",
            author: (_b = detail.author) !== null && _b !== void 0 ? _b : undefined,
            isbn: (_c = detail.isbn) !== null && _c !== void 0 ? _c : undefined,
            year: (_d = detail.copyrightFrom) !== null && _d !== void 0 ? _d : undefined,
            publisherId: (_e = detail.ownerId) !== null && _e !== void 0 ? _e : undefined,
            publisherName: (_f = detail.publisherNameToCheck) !== null && _f !== void 0 ? _f : undefined,
            place: (_g = detail.publisherPlaceToCheck) !== null && _g !== void 0 ? _g : undefined,
            note: (_h = detail.provisionalNote) !== null && _h !== void 0 ? _h : "",
        };
    }, [provisionalTitleQuery.data]);
    var handleOpenCrossLibrary = useCallback(function () { return setCrossLibraryOpen(true); }, []);
    var handleCloseCrossLibrary = useCallback(function () { return setCrossLibraryOpen(false); }, []);
    var handleOpenLibraryNote = useCallback(function () { return setLibraryNoteDialogOpen(true); }, []);
    var handleCloseLibraryNote = useCallback(function () { return setLibraryNoteDialogOpen(false); }, []);
    var _35 = useTitleWithIsbnFilters(), filters = _35.filters, appliedFilters = _35.appliedFilters, publisherQuery = _35.publisherQuery, handleFilterChange = _35.handleFilterChange, handleStatusChange = _35.handleStatusChange, handlePublisherInput = _35.handlePublisherInput, handleApplyFilters = _35.handleApplyFilters, handleClearFilters = _35.handleClearFilters, isAnyFilterActive = _35.isAnyFilterActive, hasUnappliedChanges = _35.hasUnappliedChanges;
    var _36 = usePublishersData(publisherQuery, filters.publisherId, withIsbn ? "WITH_ISBN" : "WITHOUT_ISBN"), publishers = _36.publishers, isPublishersLoading = _36.isPublishersLoading, selectedPublisher = _36.selectedPublisher;
    var baseColumns = useTitlesIsbnTable(withIsbn).columns;
    var sortKeys = useMemo(function () { return columnSortKeys(baseColumns); }, [baseColumns]);
    var _37 = useTitleSort(withIsbn ? "enforcement.withIsbn" : "enforcement.withoutIsbn", sortKeys), sort = _37.sort, handleSort = _37.handleSort;
    var _38 = useTitlesIsbnData(appliedFilters, withIsbn, sort), titlesData = _38.titlesData, totalRecords = _38.totalRecords, exactTotalRecords = _38.exactTotalRecords, isCountCapped = _38.isCountCapped, isLoading = _38.isLoading, isFetching = _38.isFetching, isError = _38.isError, error = _38.error, refetchTitles = _38.refetch, fetchMoreData = _38.fetchMoreData, pageOffset = _38.pageOffset, pageSize = _38.pageSize, changePageSize = _38.changePageSize;
    var errorMessage = useListErrorMessage(error, AGENDA_STATE_LIST_ERRORS);
    // a row the periodicals handle is read-only here, so it is never picked explicitly
    var pageIds = useMemo(function () {
        return titlesData
            .filter(function (t) { return !!t.id && !handledElsewhere(t.agenda, "MONOGRAPHS"); })
            .map(function (t) { return unitKey(t.id, t.periodicalIssueId); });
    }, [titlesData]);
    var matchFilter = useMemo(function () {
        var trimmedTitle = appliedFilters.name.trim();
        var trimmedIsbn = appliedFilters.isbn.trim();
        var trimmedPublisher = appliedFilters.publisherId.trim();
        var trimmedDays = appliedFilters.days.trim();
        var parsedDays = trimmedDays ? Number(trimmedDays) : NaN;
        var depositStatuses = expandVolumeStatuses(appliedFilters.statuses);
        var partiallyReceived = appliedFilters.statuses.includes("partial");
        var enforcementTypes = expandEnforcementTypes(appliedFilters.statuses);
        return {
            title: trimmedTitle || undefined,
            isbn: trimmedIsbn || undefined,
            publisherId: trimmedPublisher || undefined,
            minDaysSinceUrgence: Number.isFinite(parsedDays) ? parsedDays : undefined,
            statuses: depositStatuses.length > 0 ? depositStatuses : undefined,
            enforcementTypes: enforcementTypes.length > 0 ? enforcementTypes : undefined,
            partiallyReceived: partiallyReceived || undefined,
            provisionalOnly: appliedFilters.provisional || undefined,
            extraCopies: appliedFilters.extraCopies || undefined,
            extraCopyReason: appliedFilters.extraCopyReason
                ? appliedFilters.extraCopyReason
                : undefined,
            agendaState: appliedFilters.agendaState || undefined,
            withIsbn: withIsbn,
        };
    }, [appliedFilters, withIsbn]);
    var selection = useSelection({
        pageIds: pageIds,
        totalCount: totalRecords !== null && totalRecords !== void 0 ? totalRecords : pageIds.length,
        exactTotalCount: exactTotalRecords,
        isCountCapped: isCountCapped,
        filterDeps: [appliedFilters],
    });
    var checkboxColumn = useMemo(function () { return ({
        name: (React.createElement(Checkbox, { checked: selection.isAllPageSelected, onChange: selection.togglePage })),
        key: "select",
        locked: true,
        cellRenderer: function (item) {
            var rowKey = unitKey(item.id, item.periodicalIssueId);
            var isChecked = selection.isRowSelected(rowKey);
            var isLocked = selection.mode === "all" ||
                handledElsewhere(item.agenda, "MONOGRAPHS");
            return (React.createElement(RowClickBoundary, { className: isChecked ? styles.checkboxActive : styles.checkboxMuted },
                React.createElement(Checkbox, { checked: isChecked, disabled: isLocked, onChange: function () { return selection.toggleRow(rowKey); } })));
        },
    }); }, [selection]);
    var columns = useMemo(function () {
        var mapped = baseColumns.map(function (col) {
            if (col.key === "mainTitle") {
                return __assign(__assign({}, col), { clickable: true, onClick: function (item) { return handleSelectTitle(item); } });
            }
            return col;
        });
        return __spreadArray([checkboxColumn], mapped, true);
    }, [baseColumns, checkboxColumn]);
    var toggleFilterPane = useCallback(function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); }, []);
    var source = createStripesSource({
        ky: null,
        data: titlesData,
        totalRecords: totalRecords,
        isLoading: isLoading,
        isError: isError,
        errorMessage: errorMessage,
        isLoaded: true,
        fetchMore: function () { return fetchMoreData(pageOffset + pageSize); },
    });
    var _39 = useQuery(["deposit-records-by-title", selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id], function () { return fetchDepositRecordsByTitle(kyInstance, selectedTitle.id); }, { enabled: !!(selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id) }), _40 = _39.data, titleDepositRecords = _40 === void 0 ? EMPTY_DEPOSIT_RECORDS : _40, isDepositRecordsLoading = _39.isLoading;
    var selectedIssueId = (_b = selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.periodicalIssueId) !== null && _b !== void 0 ? _b : null;
    var isIssueRow = !!selectedIssueId;
    // by-title answers every copy of the periodical; an issue row is only that issue's copies
    var depositRecords = useMemo(function () {
        var _a;
        if (!selectedIssueId)
            return titleDepositRecords;
        var rowRecordIds = new Set((_a = selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.depositRecordIds) !== null && _a !== void 0 ? _a : []);
        return titleDepositRecords.filter(function (record) { return rowRecordIds.has(record.id); });
    }, [titleDepositRecords, selectedIssueId, selectedTitle]);
    var readOnlyHere = handledElsewhere(selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.agenda, "MONOGRAPHS");
    var titleAgendaQuery = useTitleAgenda(selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id);
    var takeOverByIssue = isIssueRow || !!((_c = titleAgendaQuery.data) === null || _c === void 0 ? void 0 : _c.decidedByLinkedIssue);
    var agendaIssueId = selectedIssueId !== null && selectedIssueId !== void 0 ? selectedIssueId : (readOnlyHere && takeOverByIssue
        ? ((_f = (_e = (_d = titleAgendaQuery.data) === null || _d === void 0 ? void 0 : _d.specialIssueLink) === null || _e === void 0 ? void 0 : _e.issueId) !== null && _f !== void 0 ? _f : null)
        : null);
    var issueAgendaQuery = useIssueAgenda(agendaIssueId);
    var _41 = useIsNationalLibrary(), isNationalLibrary = _41.isNationalLibrary, activeLibraryId = _41.activeLibraryId;
    var canChangeIssueAgenda = isIssueRow &&
        (!!((_g = issueAgendaQuery.data) === null || _g === void 0 ? void 0 : _g.canDecideOnItsOwn) ||
            !!((_h = issueAgendaQuery.data) === null || _h === void 0 ? void 0 : _h.overridden));
    var detailName = useMemo(function () {
        return [selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.mainTitle, selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.issueLabel]
            .filter(Boolean)
            .join(" \u2013 ");
    }, [selectedTitle]);
    var hasIssueRowsSelected = useMemo(function () { return Array.from(selection.includeIds).some(isIssueUnitKey); }, [selection.includeIds]);
    var requestCopyBlockedByIssues = selection.mode !== "all" && hasIssueRowsSelected;
    var singleUnitSelection = useMemo(function () {
        return selectedIssueId
            ? { includeIssueIds: [selectedIssueId] }
            : { includeIds: (selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id) ? [selectedTitle.id] : [] };
    }, [selectedIssueId, selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id]);
    var toggleEnforcementRecord = useCallback(function (recordId) {
        setExpandedEnforcementRecordIds(function (prev) {
            var next = new Set(prev);
            if (next.has(recordId)) {
                next.delete(recordId);
            }
            else {
                next.add(recordId);
            }
            return next;
        });
    }, []);
    var selectedForUrgenceSorted = useMemo(function () { return Array.from(selectedForUrgence).sort(); }, [selectedForUrgence]);
    var buildBulkSelection = useCallback(function () {
        return buildEnforcementSelection({
            mode: selection.mode,
            includeIds: selection.includeIds,
            excludeIds: selection.excludeIds,
        }, matchFilter);
    }, [selection.mode, selection.includeIds, selection.excludeIds, matchFilter]);
    var selectionKind = bulkUrgenceMode === "single-title-reminder" ||
        bulkUrgenceMode === "bulk-reminder"
        ? "REMINDER"
        : bulkUrgenceMode === "single-title" ||
            bulkUrgenceMode === "selected" ||
            bulkUrgenceMode === "all-publisher"
            ? "URGENCE"
            : null;
    var sendPhase = sendRecordIds === null ? "select" : "message";
    var selectionFingerprint = useMemo(function () { return [
        selection.mode,
        Array.from(selection.includeIds).sort(),
        Array.from(selection.excludeIds).sort(),
        matchFilter,
    ]; }, [selection.mode, selection.includeIds, selection.excludeIds, matchFilter]);
    var _42 = useQuery([
        "urgence-preview",
        bulkUrgenceMode,
        sendRecordIds,
        selectedForUrgenceSorted,
        selectionFingerprint,
        filters.publisherId,
        selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id,
    ], function () {
        if (selectionKind && sendRecordIds !== null) {
            return previewUrgence(kyInstance, sendRecordIds, selectionKind, "MONOGRAPHS");
        }
        if (bulkUrgenceMode === "single-title") {
            return previewUrgence(kyInstance, selectedForUrgenceSorted, "URGENCE", "MONOGRAPHS");
        }
        if (bulkUrgenceMode === "single-title-reminder") {
            return previewUrgence(kyInstance, selectedForUrgenceSorted, "REMINDER", "MONOGRAPHS");
        }
        if (bulkUrgenceMode === "selected") {
            return previewUrgenceByTitles(kyInstance, buildBulkSelection());
        }
        if (bulkUrgenceMode === "bulk-reminder") {
            return previewUrgenceByTitles(kyInstance, buildBulkSelection(), "REMINDER");
        }
        if (bulkUrgenceMode === "all-publisher" && filters.publisherId) {
            return previewUrgenceByPublisher(kyInstance, filters.publisherId);
        }
        if (bulkUrgenceMode === "request-copy" && (selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id)) {
            return previewRequestCopy(kyInstance, selectedTitle.id);
        }
        if (bulkUrgenceMode === "damaged-claim" && (selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id)) {
            return previewDamagedClaimByTitles(kyInstance, singleUnitSelection);
        }
        if (bulkUrgenceMode === "bulk-damaged-claim") {
            return previewDamagedClaimByTitles(kyInstance, buildBulkSelection());
        }
        if (bulkUrgenceMode === "bulk-request-copy") {
            return previewRequestCopyByTitles(kyInstance, buildBulkSelection());
        }
        return null;
    }, {
        enabled: showSendDialog && bulkUrgenceMode !== null,
        staleTime: 30000,
        cacheTime: 60000,
    }), urgencePreview = _42.data, urgencePreviewFetching = _42.isFetching, urgencePreviewError = _42.error;
    var excludePreview = useQuery(["exclude-preview", selectionFingerprint], function () { return previewExcludeByTitles(kyInstance, buildBulkSelection()); }, {
        enabled: showExcludeDialog &&
            bulkUrgenceMode === "bulk-exclude" &&
            selection.selectedCount > 0,
        staleTime: 30000,
    }).data;
    var invalidateDepositRecords = useCallback(function () {
        invalidateDepositRecordViews(queryClient);
        refetchTitles();
    }, [queryClient, refetchTitles]);
    var handleBulkError = useCallback(function (err) { return __awaiter(void 0, void 0, void 0, function () {
        var domainCode, body, _a, message;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, readErrorCode(err)];
                case 1:
                    domainCode = _d.sent();
                    if (domainCode && AGENDA_ERROR_CODES.has(domainCode)) {
                        setBulkErrorMessage(formatMessage({
                            id: "ui-br-legaldeposits.field.error.".concat(domainCode),
                        }));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, readUrgenceErrorCode(err)];
                case 2:
                    if ((_d.sent()) === "REMINDER_ALREADY_ACTIVE") {
                        setBulkErrorMessage(formatMessage({
                            id: "ui-br-legaldeposits.enforcement.error.REMINDER_ALREADY_ACTIVE",
                        }));
                        return [2 /*return*/];
                    }
                    if (!(hasHttpResponse(err) && err.response.status === 422)) return [3 /*break*/, 7];
                    body = null;
                    _d.label = 3;
                case 3:
                    _d.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, err.response.clone().json()];
                case 4:
                    body = _d.sent();
                    return [3 /*break*/, 6];
                case 5:
                    _a = _d.sent();
                    body = null;
                    return [3 /*break*/, 6];
                case 6:
                    message = (body === null || body === void 0 ? void 0 : body.message) ||
                        ((_c = (_b = body === null || body === void 0 ? void 0 : body.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.message) ||
                        formatMessage({
                            id: "ui-br-legaldeposits.selection.limitExceeded.error",
                        });
                    setBulkErrorMessage(message);
                    return [2 /*return*/];
                case 7:
                    setBulkErrorMessage(formatMessage({ id: "ui-br-legaldeposits.bulk.error.generic" }));
                    return [2 /*return*/];
            }
        });
    }); }, [formatMessage]);
    useEffect(function () {
        if (!urgencePreviewError)
            return;
        setShowSendDialog(false);
        setBulkUrgenceMode(null);
        setSendRecordIds(null);
        handleBulkError(urgencePreviewError);
        // react-query keeps a failed query's error while refetching, so a reopened dialog would close on the stale error
        queryClient.removeQueries(["urgence-preview"]);
    }, [urgencePreviewError, handleBulkError, queryClient]);
    var urgenceMutation = useMutation(function (_a) {
        var formData = _a.formData, depositRecordIds = _a.depositRecordIds, publisherId = _a.publisherId;
        if (bulkUrgenceMode === "single-title" ||
            bulkUrgenceMode === "single-title-reminder") {
            return createUrgence(kyInstance, {
                depositRecordIds: depositRecordIds,
                communicationType: formData.communicationType,
                subject: formData.subject,
                body: formData.body,
                recipientAddress: formData.recipientAddress,
                notes: formData.notes,
                enforcementType: bulkUrgenceMode === "single-title-reminder"
                    ? "REMINDER"
                    : "URGENCE",
            }, "MONOGRAPHS");
        }
        if (bulkUrgenceMode === "selected" ||
            bulkUrgenceMode === "bulk-reminder") {
            return createUrgenceByTitles(kyInstance, {
                selection: buildBulkSelection(),
                communicationType: formData.communicationType,
                subject: formData.subject,
                body: formData.body,
                recipientAddress: formData.recipientAddress,
                notes: formData.notes,
                enforcementType: bulkUrgenceMode === "bulk-reminder" ? "REMINDER" : "URGENCE",
                depositRecordIds: sendRecordIds !== null && sendRecordIds !== void 0 ? sendRecordIds : undefined,
            });
        }
        if (bulkUrgenceMode === "request-copy" && (selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id)) {
            return requestCopy(kyInstance, selectedTitle.id, {
                communicationType: formData.communicationType,
                subject: formData.subject,
                body: formData.body,
                recipientAddress: formData.recipientAddress,
                notes: formData.notes,
            });
        }
        if (bulkUrgenceMode === "damaged-claim" && (selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id)) {
            return sendDamagedClaimByTitles(kyInstance, {
                selection: singleUnitSelection,
                communicationType: formData.communicationType,
                subject: formData.subject,
                body: formData.body,
                recipientAddress: formData.recipientAddress,
                notes: formData.notes,
            });
        }
        if (bulkUrgenceMode === "bulk-damaged-claim") {
            return sendDamagedClaimByTitles(kyInstance, {
                selection: buildBulkSelection(),
                communicationType: formData.communicationType,
                subject: formData.subject,
                body: formData.body,
                recipientAddress: formData.recipientAddress,
                notes: formData.notes,
            });
        }
        if (bulkUrgenceMode === "bulk-request-copy") {
            return requestCopyByTitles(kyInstance, {
                selection: buildBulkSelection(),
                communicationType: formData.communicationType,
                subject: formData.subject,
                body: formData.body,
                recipientAddress: formData.recipientAddress,
                notes: formData.notes,
            });
        }
        return createUrgenceByPublisher(kyInstance, {
            publisherId: publisherId,
            communicationType: formData.communicationType,
            subject: formData.subject,
            body: formData.body,
            recipientAddress: formData.recipientAddress,
            notes: formData.notes,
            depositRecordIds: sendRecordIds !== null && sendRecordIds !== void 0 ? sendRecordIds : undefined,
        });
    }, {
        onSuccess: function (result) {
            setShowSendDialog(false);
            setSelectedForUrgence(new Set());
            selection.clearSelection();
            setBulkUrgenceMode(null);
            setBulkErrorMessage(null);
            setSendRecordIds(null);
            // the request-copy and damaged-claim branches of this mutation answer with
            // their own shapes, so only an urgence result carries skipped records
            var urgenceResult = result;
            setExecutedSkippedHandledElsewhere(skippedHandledElsewhereOf(result));
            setSkippedSummary(summarizeSkippedRecords(urgenceResult === null || urgenceResult === void 0 ? void 0 : urgenceResult.skipped, formatMessage));
            setSendResultMessage(selectionKind
                ? describeSendResult(urgenceResult, selectionKind, formatMessage)
                : null);
            invalidateDepositRecords();
        },
        onError: handleBulkError,
    });
    var excludeMutation = useMutation(function (_a) {
        var reason = _a.reason, note = _a.note;
        if (bulkUrgenceMode === "bulk-exclude") {
            return excludeByTitles(kyInstance, {
                selection: buildBulkSelection(),
                reason: reason,
                note: note,
            });
        }
        if (selectedIssueId) {
            return excludeByTitles(kyInstance, {
                selection: { includeIssueIds: [selectedIssueId] },
                reason: reason,
                note: note,
            });
        }
        return excludeTitle(kyInstance, selectedTitle.id, { reason: reason, note: note });
    }, {
        onSuccess: function (result) {
            setExecutedSkippedHandledElsewhere(skippedHandledElsewhereOf(result));
            setShowExcludeDialog(false);
            selection.clearSelection();
            setBulkUrgenceMode(null);
            setBulkErrorMessage(null);
            invalidateDepositRecords();
        },
        onError: handleBulkError,
    });
    var addExtraCopyMutation = useMutation(function (_a) {
        var titleId = _a.titleId, issueId = _a.issueId, reason = _a.reason, note = _a.note;
        return addExtraCopy(kyInstance, titleId, {
            reason: reason,
            note: note || undefined,
            issueId: issueId !== null && issueId !== void 0 ? issueId : undefined,
        });
    }, {
        onSuccess: function () {
            setShowExtraCopyDialog(false);
            invalidateDepositRecords();
        },
    });
    var reinstateMutation = useMutation(function (_a) {
        var titleId = _a.titleId, issueId = _a.issueId;
        return issueId
            ? reinstateByTitles(kyInstance, { includeIssueIds: [issueId] })
            : reinstateTitle(kyInstance, titleId);
    }, {
        onSuccess: function (result) {
            setExecutedSkippedHandledElsewhere(skippedHandledElsewhereOf(result));
            setShowReinstateDialog(false);
            invalidateDepositRecords();
        },
    });
    var extraCopyErrorMessage = useServerErrorMessage(addExtraCopyMutation.error, "ui-br-legaldeposits.field.error.generic");
    var reinstateErrorMessage = useServerErrorMessage(reinstateMutation.error, "ui-br-legaldeposits.field.error.generic");
    var resetAddExtraCopy = addExtraCopyMutation.reset;
    var resetReinstate = reinstateMutation.reset;
    var closeExtraCopyDialog = useCallback(function () {
        setShowExtraCopyDialog(false);
        resetAddExtraCopy();
    }, [resetAddExtraCopy]);
    var closeReinstateDialog = useCallback(function () {
        setShowReinstateDialog(false);
        resetReinstate();
    }, [resetReinstate]);
    var handleAddExtraCopy = useCallback(function (reason, note) {
        if (!(selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id))
            return;
        addExtraCopyMutation.mutate({
            titleId: selectedTitle.id,
            issueId: selectedIssueId,
            reason: reason,
            note: note,
        });
    }, [addExtraCopyMutation, selectedTitle, selectedIssueId]);
    var handleReinstate = useCallback(function () {
        if (!(selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id))
            return;
        reinstateMutation.mutate({
            titleId: selectedTitle.id,
            issueId: selectedIssueId,
        });
    }, [reinstateMutation, selectedTitle, selectedIssueId]);
    var receiveMutation = useMutation(function (depositRecordId) { return receiveDeposit(kyInstance, depositRecordId); }, {
        onSuccess: function () {
            invalidateDepositRecords();
        },
    });
    var damagedMutation = useMutation(function (depositRecordId) { return reportDamaged(kyInstance, depositRecordId); }, {
        onSuccess: function () {
            invalidateDepositRecords();
        },
    });
    var interpretScanResponse = useCallback(function (result, isbn, titleId) {
        var _a, _b, _c, _d, _e, _f, _g;
        var silent = { success: false, silent: true, message: "" };
        var failure = function (id, values) { return ({
            success: false,
            message: formatMessage({ id: id }, values),
        }); };
        var library = function () {
            var _a, _b;
            return formatLibraryName((_a = result.depositRecord) === null || _a === void 0 ? void 0 : _a.libraryName, (_b = result.depositRecord) === null || _b === void 0 ? void 0 : _b.libraryStatus, formatMessage);
        };
        switch (result.status) {
            case "RECEIVED":
                invalidateDepositRecords();
                return {
                    success: true,
                    message: formatMessage({ id: "ui-br-legaldeposits.enforcement.scan.success" }, {
                        isbn: isbn,
                        library: library(),
                        title: (_b = (_a = result.depositRecord) === null || _a === void 0 ? void 0 : _a.titleName) !== null && _b !== void 0 ? _b : "",
                    }),
                };
            case "CONFIRMATION_NEEDED":
                return {
                    success: false,
                    needsConfirmation: true,
                    message: formatMessage({
                        id: "ui-br-legaldeposits.enforcement.scan.alreadyReceivedToday",
                    }, {
                        isbn: isbn,
                        library: library(),
                        title: (_d = (_c = result.depositRecord) === null || _c === void 0 ? void 0 : _c.titleName) !== null && _d !== void 0 ? _d : "",
                    }),
                    confirmAction: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _a = interpretScanResponse;
                                    return [4 /*yield*/, receiveByIsbn(kyInstance, isbn, true, titleId)];
                                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent(), isbn,
                                        titleId])];
                            }
                        });
                    }); },
                };
            case "ALL_RECEIVED": {
                var offeredTitleId_1 = result.titleId, titleName_1 = result.titleName;
                if (result.action === "EXTRA_COPY" && offeredTitleId_1) {
                    return {
                        success: false,
                        message: formatMessage({ id: "ui-br-legaldeposits.enforcement.scan.extraCopyOffer" }, { isbn: isbn, title: titleName_1 !== null && titleName_1 !== void 0 ? titleName_1 : "" }),
                        offer: {
                            label: formatMessage({
                                id: "ui-br-legaldeposits.enforcement.scan.receiveAsExtraCopy",
                            }),
                            onAccept: function () {
                                return setExtraCopyScan({
                                    isbn: isbn,
                                    titleId: offeredTitleId_1,
                                    titleName: titleName_1,
                                });
                            },
                        },
                    };
                }
                return failure("ui-br-legaldeposits.enforcement.scan.noReceivable", {
                    isbn: isbn,
                });
            }
            case "PENDING_VERIFICATION":
                if (result.pendingTitle) {
                    setPendingVerification({ isbn: isbn, pendingTitle: result.pendingTitle });
                    return silent;
                }
                return failure("ui-br-legaldeposits.enforcement.scan.pendingVerification", { isbn: isbn });
            case "NOT_FOUND":
                return failure("ui-br-legaldeposits.enforcement.scan.notFound", {
                    isbn: isbn,
                });
            case "INVALID_NUMBER":
                return failure("ui-br-legaldeposits.enforcement.scan.invalidNumber");
            case "FOREIGN_NUMBER":
                return failure("ui-br-legaldeposits.enforcement.scan.foreignNumber");
            case "FOUND_IN_AGENCY":
                if (result.agencyProductId && result.agencyTitle) {
                    setAgencyConfirm({
                        isbn: isbn,
                        agencyProductId: result.agencyProductId,
                        agencyTitle: result.agencyTitle,
                    });
                    return silent;
                }
                return failure("ui-br-legaldeposits.enforcement.scan.error");
            case "NOT_FOUND_IN_AGENCY":
                setProvisionalScanIsbn(isbn);
                return silent;
            case "DUPLICATE_TITLES":
                if (((_f = (_e = result.duplicateTitles) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0) > 1) {
                    setScanDuplicates({ isbn: isbn, titles: (_g = result.duplicateTitles) !== null && _g !== void 0 ? _g : [] });
                    return silent;
                }
                return failure("ui-br-legaldeposits.enforcement.scan.error");
            default:
                // An unknown status may or may not have booked the copy, so never report it as received.
                return {
                    success: false,
                    message: formatMessage({ id: "ui-br-legaldeposits.enforcement.scan.unknownStatus" }, { status: String(result.status) }),
                };
        }
    }, [kyInstance, formatMessage, invalidateDepositRecords]);
    var scanErrorMessage = useCallback(function (err) { return __awaiter(void 0, void 0, void 0, function () {
        var code;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, readErrorCode(err)];
                case 1:
                    code = _a.sent();
                    if (code && AGENDA_ERROR_CODES.has(code)) {
                        return [2 /*return*/, formatMessage({ id: "ui-br-legaldeposits.field.error.".concat(code) })];
                    }
                    return [2 /*return*/, formatMessage({
                            id: code === "TITLE_NOT_IN_ISBN_MATCHES"
                                ? "ui-br-legaldeposits.titleMerge.scan.titleNoLongerMatches"
                                : "ui-br-legaldeposits.enforcement.scan.error",
                        })];
            }
        });
    }); }, [formatMessage]);
    var handleScan = useCallback(function (isbn) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, err_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 4]);
                    _a = interpretScanResponse;
                    return [4 /*yield*/, receiveByIsbn(kyInstance, isbn)];
                case 1: return [2 /*return*/, _a.apply(void 0, [_c.sent(), isbn])];
                case 2:
                    err_1 = _c.sent();
                    _b = { success: false };
                    return [4 /*yield*/, scanErrorMessage(err_1)];
                case 3: return [2 /*return*/, (_b.message = _c.sent(), _b)];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [kyInstance, interpretScanResponse, scanErrorMessage]);
    var confirmAgencyMutation = useMutation(function (_a) {
        var isbn = _a.isbn, agencyProductId = _a.agencyProductId;
        return confirmAgencyTitle(kyInstance, isbn, agencyProductId);
    }, {
        onSuccess: function (data, variables) {
            var _a;
            setAgencyConfirm(null);
            (_a = scanBarRef.current) === null || _a === void 0 ? void 0 : _a.showResult(interpretScanResponse(data, variables.isbn));
        },
        onError: function () {
            var _a;
            setAgencyConfirm(null);
            (_a = scanBarRef.current) === null || _a === void 0 ? void 0 : _a.showResult({
                success: false,
                message: formatMessage({
                    id: "ui-br-legaldeposits.enforcement.scan.error",
                }),
            });
        },
    });
    var scanReceiveMutation = useMutation(function (_a) {
        var isbn = _a.isbn, titleId = _a.titleId;
        return receiveByIsbn(kyInstance, isbn, false, titleId);
    }, {
        onSuccess: function (data, variables) {
            var _a;
            setScanDuplicates(null);
            (_a = scanBarRef.current) === null || _a === void 0 ? void 0 : _a.showResult(interpretScanResponse(data, variables.isbn, variables.titleId));
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b, _c;
            var _d;
            var _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        setScanDuplicates(null);
                        if (!((_e = 
                        // The dialog's list can go stale under the librarian (a parallel merge or edit), and then
                        // the chosen title no longer carries the scanned number - say so instead of "something failed".
                        scanBarRef.current) === null || _e === void 0)) return [3 /*break*/, 1];
                        _a = void 0;
                        return [3 /*break*/, 3];
                    case 1:
                        _c = (_b = _e).showResult;
                        _d = {
                            success: false
                        };
                        return [4 /*yield*/, scanErrorMessage(error)];
                    case 2:
                        _a = _c.apply(_b, [(_d.message = _f.sent(),
                                _d)]);
                        _f.label = 3;
                    case 3:
                        // The dialog's list can go stale under the librarian (a parallel merge or edit), and then
                        // the chosen title no longer carries the scanned number - say so instead of "something failed".
                        _a;
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var receiveExtraCopyMutation = useMutation(function (_a) {
        var isbn = _a.isbn, titleId = _a.titleId, reason = _a.reason, note = _a.note;
        return receiveExtraCopy(kyInstance, titleId, {
            isbn: isbn,
            reason: reason,
            note: note || undefined,
        });
    }, {
        onSuccess: function (record, variables) {
            var _a, _b, _c, _d;
            setExtraCopyScan(null);
            invalidateDepositRecords();
            var reasonLabelId = (_a = EXTRA_COPY_REASONS.find(function (option) { return option.value === record.extraCopyReason; })) === null || _a === void 0 ? void 0 : _a.labelId;
            (_b = scanBarRef.current) === null || _b === void 0 ? void 0 : _b.showResult({
                success: true,
                message: formatMessage({ id: "ui-br-legaldeposits.enforcement.scan.receivedAsExtraCopy" }, {
                    isbn: variables.isbn,
                    title: (_c = record.titleName) !== null && _c !== void 0 ? _c : "",
                    library: formatLibraryName(record.libraryName, record.libraryStatus, formatMessage),
                    reason: reasonLabelId
                        ? formatMessage({ id: reasonLabelId })
                        : String((_d = record.extraCopyReason) !== null && _d !== void 0 ? _d : ""),
                }),
            });
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var code;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setExtraCopyScan(null);
                        return [4 /*yield*/, readMergeError(error)];
                    case 1:
                        code = (_c.sent()).code;
                        (_a = scanBarRef.current) === null || _a === void 0 ? void 0 : _a.showResult({
                            success: false,
                            message: formatMessage({
                                id: (_b = EXTRA_COPY_ERROR_IDS[code !== null && code !== void 0 ? code : ""]) !== null && _b !== void 0 ? _b : (code
                                    ? "ui-br-legaldeposits.enforcement.scan.extraCopyFailed"
                                    : "ui-br-legaldeposits.enforcement.scan.error"),
                            }, { code: code !== null && code !== void 0 ? code : "" }),
                        });
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var handleScanReceiveAsExtraCopy = useCallback(function (title) {
        if (!scanDuplicates)
            return;
        setExtraCopyScan({
            isbn: scanDuplicates.isbn,
            titleId: title.titleId,
            titleName: title.name,
        });
        setScanDuplicates(null);
    }, [scanDuplicates]);
    var handleOpenMerge = useCallback(function (request) {
        setMergeCompletion(null);
        setMergeRequest(request);
    }, []);
    var handleScanMergeAll = useCallback(function () {
        if (!scanDuplicates)
            return;
        setMergeFromScanIsbn(scanDuplicates.isbn);
        handleOpenMerge({
            titleIds: scanDuplicates.titles.map(function (title) { return title.titleId; }),
            titleType: "MONOGRAPH",
        });
        setScanDuplicates(null);
    }, [scanDuplicates, handleOpenMerge]);
    var handleMerged = useCallback(function (completion) { return __awaiter(void 0, void 0, void 0, function () {
        var isbn, mergedMessage, receipt, _a, err_2, _b, _c, _d, _e, _f;
        var _g;
        var _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    setMergeCompletion(completion);
                    if ((selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id) &&
                        completion.plan.duplicateIds.includes(selectedTitle.id)) {
                        handleCloseSelectedTitle();
                    }
                    isbn = mergeFromScanIsbn;
                    setMergeFromScanIsbn(null);
                    if (!isbn)
                        return [2 /*return*/];
                    mergedMessage = formatMessage({ id: "ui-br-legaldeposits.titleMerge.scan.merged" }, { count: completion.absorbedCount, name: completion.survivorName });
                    _k.label = 1;
                case 1:
                    _k.trys.push([1, 3, , 7]);
                    _a = interpretScanResponse;
                    return [4 /*yield*/, receiveByIsbn(kyInstance, isbn, false, completion.survivorId)];
                case 2:
                    receipt = _a.apply(void 0, [_k.sent(), isbn,
                        completion.survivorId]);
                    (_h = scanBarRef.current) === null || _h === void 0 ? void 0 : _h.showResult(receipt.silent
                        ? {
                            success: false,
                            variant: "warning",
                            message: "".concat(mergedMessage, " ").concat(formatMessage({
                                id: "ui-br-legaldeposits.titleMerge.scan.receiptNeedsAttention",
                            })),
                        }
                        : __assign(__assign({}, receipt), { message: "".concat(mergedMessage, " ").concat(receipt.message) }));
                    return [3 /*break*/, 7];
                case 3:
                    err_2 = _k.sent();
                    if (!((_j = scanBarRef.current) === null || _j === void 0)) return [3 /*break*/, 4];
                    _b = void 0;
                    return [3 /*break*/, 6];
                case 4:
                    _d = (_c = _j).showResult;
                    _g = {
                        success: false
                    };
                    _f = (_e = "".concat(mergedMessage, " ")).concat;
                    return [4 /*yield*/, scanErrorMessage(err_2)];
                case 5:
                    _b = _d.apply(_c, [(_g.message = _f.apply(_e, [_k.sent()]),
                            _g)]);
                    _k.label = 6;
                case 6:
                    _b;
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); }, [
        selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id,
        handleCloseSelectedTitle,
        mergeFromScanIsbn,
        formatMessage,
        interpretScanResponse,
        kyInstance,
        scanErrorMessage,
    ]);
    var handleAgencyConfirm = useCallback(function () {
        if (!agencyConfirm)
            return;
        confirmAgencyMutation.mutate({
            isbn: agencyConfirm.isbn,
            agencyProductId: agencyConfirm.agencyProductId,
        });
    }, [agencyConfirm, confirmAgencyMutation]);
    var handleAgencyReject = useCallback(function () {
        if (!agencyConfirm)
            return;
        var isbn = agencyConfirm.isbn;
        setAgencyConfirm(null);
        setProvisionalScanIsbn(isbn);
    }, [agencyConfirm]);
    var handleAgencyClose = useCallback(function () { return setAgencyConfirm(null); }, []);
    var handlePendingVerificationOpen = useCallback(function () {
        if (!pendingVerification)
            return;
        var titleId = pendingVerification.pendingTitle.titleId;
        setPendingVerification(null);
        history.push("".concat(ROUTE_PATHS.TITLES_VERIFICATION, "?detail=").concat(titleId));
    }, [pendingVerification, history]);
    var handlePendingVerificationClose = useCallback(function () { return setPendingVerification(null); }, []);
    var handleProvisionalCreateClose = useCallback(function () {
        setProvisionalScanIsbn(null);
        setProvisionalCreateOpen(false);
    }, []);
    var provisionalScanInitialValues = useMemo(function () {
        return provisionalScanIsbn != null
            ? { name: "", isbn: provisionalScanIsbn, note: "" }
            : undefined;
    }, [provisionalScanIsbn]);
    var handleCloseDetail = useCallback(function () {
        handleCloseSelectedTitle();
        setExpandedEnforcementRecordIds(new Set());
        setSelectedForUrgence(new Set());
    }, [handleCloseSelectedTitle]);
    var openBulkUrgence = useCallback(function (mode) {
        setBulkErrorMessage(null);
        setBulkUrgenceMode(mode);
        setShowSendDialog(true);
    }, []);
    var openBulkExclude = useCallback(function () {
        setBulkErrorMessage(null);
        setBulkUrgenceMode("bulk-exclude");
        setShowExcludeDialog(true);
    }, []);
    var titleInfo = useMemo(function () { return (selectedTitle ? toTitleInfo(selectedTitle) : undefined); }, [selectedTitle]);
    var selectedTitleCanRecordPreLitigation = useMemo(function () {
        var _a;
        return ((_a = selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.depositStatusesPerRecord) !== null && _a !== void 0 ? _a : []).some(function (recordStatuses) {
            return recordStatuses.includes("URGED") ||
                recordStatuses.includes("PRE_LITIGATION");
        });
    }, [selectedTitle]);
    var detailSubtitle = useMemo(function () {
        var _a, _b;
        return [
            selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.publisher,
            formatLibraryName((_a = depositRecords[0]) === null || _a === void 0 ? void 0 : _a.libraryName, (_b = depositRecords[0]) === null || _b === void 0 ? void 0 : _b.libraryStatus, formatMessage),
        ]
            .filter(Boolean)
            .join(" \u2014 ");
    }, [selectedTitle, depositRecords, formatMessage]);
    var handleCloseAgendaDialog = useCallback(function () { return setAgendaDialogMode(null); }, []);
    var handleOpenAgendaOverview = useCallback(function () { return setAgendaOverviewOpen(true); }, []);
    var handleCloseAgendaOverview = useCallback(function () { return setAgendaOverviewOpen(false); }, []);
    useEffect(function () {
        setAgendaOverviewOpen(false);
    }, [selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id, selectedIssueId]);
    var handleAgendaChanged = useCallback(function (result) {
        var _a, _b, _c;
        var mode = agendaDialogMode;
        setAgendaDialogMode(null);
        setAgendaOverviewOpen(false);
        var newAgenda = (_b = (_a = result.issue) === null || _a === void 0 ? void 0 : _a.agenda) !== null && _b !== void 0 ? _b : (_c = result.title) === null || _c === void 0 ? void 0 : _c.agenda;
        setAgendaResult(mode === "global"
            ? formatMessage({ id: "ui-br-legaldeposits.agenda.result.global" }, { name: detailName })
            : formatMessage({
                id: "ui-br-legaldeposits.agenda.result.".concat(newAgenda !== null && newAgenda !== void 0 ? newAgenda : "MONOGRAPHS"),
            }, { name: detailName }));
    }, [agendaDialogMode, formatMessage, detailName]);
    var handleOpenLinkPeriodical = useCallback(function () { return setLinkPeriodicalOpen(true); }, []);
    var handleCloseLinkPeriodical = useCallback(function () { return setLinkPeriodicalOpen(false); }, []);
    var handleLinkedToPeriodical = useCallback(function (result) {
        var _a, _b;
        setLinkPeriodicalOpen(false);
        setAgendaOverviewOpen(false);
        setAgendaResult(formatMessage({ id: "ui-br-legaldeposits.agenda.result.linked" }, {
            name: detailName,
            issue: (_b = (_a = result.specialIssueLink) === null || _a === void 0 ? void 0 : _a.issueLabel) !== null && _b !== void 0 ? _b : "",
        }));
    }, [formatMessage, detailName]);
    var openTakeOver = useCallback(function () { return setAgendaDialogMode(takeOverByIssue ? "issue" : "library"); }, [takeOverByIssue]);
    var takeOverButton = (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.action.takeOver.MONOGRAPHS" }));
    var canLinkToPeriodical = canLinkSpecialIssues &&
        !isIssueRow &&
        !!activeLibraryId &&
        ((_j = titleAgendaQuery.data) === null || _j === void 0 ? void 0 : _j.agenda) === "MONOGRAPHS" &&
        !titleAgendaQuery.data.specialIssueLink;
    var paneTitleId = withIsbn
        ? "ui-br-legaldeposits.navigation.titles-with-isbn"
        : "ui-br-legaldeposits.navigation.titles-without-isbn";
    return (React.createElement(RecekPaneSet, null,
        filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-legaldeposits.pane.title.navigation",
            }) },
            React.createElement("div", { className: styles.flexColumn },
                React.createElement(NavComponent, null),
                React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !isAnyFilterActive(), marginBottom0: true, onClick: handleClearFilters },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.resetAll" })),
                React.createElement(TitleWithIsbnFilters, { filters: filters, suggestScope: withIsbn ? "WITH_ISBN" : "WITHOUT_ISBN", publishers: publishers, isPublishersLoading: isPublishersLoading, selectedPublisher: selectedPublisher, showIsbnFilter: withIsbn, agendaStateListType: activeLibraryId ? "MONOGRAPHS" : undefined, volumeStatuses: volumeStatuses, onFilterChange: handleFilterChange, onStatusChange: handleStatusChange, onPublisherInput: handlePublisherInput, onApplyFilters: handleApplyFilters, hasUnappliedChanges: hasUnappliedChanges() })))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({ id: paneTitleId }), paneSub: formatCountSubtitle(formatMessage, totalRecords, isCountCapped), actionMenu: function () { return (React.createElement(MenuSection, { label: formatMessage({
                    id: "ui-br-legaldeposits.bulk.actions.label",
                }), id: "bulk-actions-menu" },
                !withIsbn && canVerifyTitleItem && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () { return setProvisionalCreateOpen(true); } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.provisionalTitle.action" }))),
                appliedFilters.publisherId && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, disabled: selection.selectedCount === 0, onClick: function () { return openBulkUrgence("bulk-reminder"); } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.bulk.actions.reminderSelected", values: { count: selection.selectedCount } }))),
                appliedFilters.publisherId && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, disabled: selection.selectedCount === 0, onClick: function () { return openBulkUrgence("selected"); } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.bulk.actions.urgenceSelected", values: { count: selection.selectedCount } }))),
                React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, disabled: selection.selectedCount === 0, onClick: openBulkExclude },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.bulk.actions.excludeSelected", values: { count: selection.selectedCount } })),
                appliedFilters.publisherId && canRequestCopies && (React.createElement(React.Fragment, null,
                    React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, disabled: selection.selectedCount === 0 || requestCopyBlockedByIssues, onClick: function () { return openBulkUrgence("bulk-request-copy"); }, "data-test-id": "bulk-request-copy" },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.bulk.actions.requestCopySelected", values: { count: selection.selectedCount } })),
                    requestCopyBlockedByIssues && (React.createElement("div", { className: styles.menuHint, "data-test-id": "bulk-request-copy-issue-hint" },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.bulk.actions.requestCopySelected.issueRows" }))))),
                appliedFilters.publisherId && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, disabled: selection.selectedCount === 0, onClick: function () { return openBulkUrgence("bulk-damaged-claim"); } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.bulk.actions.damagedClaimSelected", values: { count: selection.selectedCount } }))),
                canMergeTitles && selection.mode === "page" && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, disabled: hasIssueRowsSelected ||
                        selection.includeIds.size < MIN_MERGE_SET_SIZE ||
                        selection.includeIds.size > MAX_MERGE_SET_SIZE, onClick: function () {
                        return handleOpenMerge({
                            titleIds: Array.from(selection.includeIds),
                            titleType: "MONOGRAPH",
                        });
                    }, "data-test-id": "bulk-action-merge" },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.bulkAction", values: { count: selection.includeIds.size } }))))); } },
            withIsbn && (React.createElement("div", { className: styles.scanBarWrapper },
                React.createElement(ScanBar, { ref: scanBarRef, onScan: handleScan }))),
            React.createElement(SelectAllBanner, { mode: selection.mode, selectedCount: selection.selectedCount, pageRecordCount: pageIds.length, totalCount: totalRecords !== null && totalRecords !== void 0 ? totalRecords : pageIds.length, exactTotalCount: exactTotalRecords, isCountCapped: isCountCapped, limit: MAX_SELECTION_SIZE, onSelectAllAcrossFilter: selection.selectAllAcrossFilter, onClear: selection.clearSelection }),
            bulkErrorMessage && (React.createElement("div", { role: "alert", className: styles.bulkError }, bulkErrorMessage)),
            sendResultMessage && (React.createElement(MessageBanner, { type: sendResultMessage.type, dismissible: true, onExited: function () { return setSendResultMessage(null); }, "data-testid": "urgence-send-result" }, sendResultMessage.text)),
            React.createElement(SkippedHandledElsewhere, { count: executedSkippedHandledElsewhere, listedIn: "MONOGRAPHS", executed: true, onDismiss: dismissExecutedSkipped }),
            skippedSummary && (React.createElement(MessageBanner, { type: "warning", dismissible: true, onExited: function () { return setSkippedSummary(null); }, "data-testid": "urgence-skipped-summary" }, skippedSummary)),
            agendaResult && (React.createElement(MessageBanner, { type: "success", dismissible: true, onExited: function () { return setAgendaResult(null); }, "data-test-id": "agenda-change-result" }, agendaResult)),
            mergeCompletion && (React.createElement(MergeResultCallout, { completion: mergeCompletion, onDismiss: function () { return setMergeCompletion(null); } })),
            React.createElement(TableComponent, { data: titlesData, columns: columns, columnWidths: withIsbn ? COLUMN_WIDTHS_WITH_ISBN : COLUMN_WIDTHS_WITHOUT_ISBN, columnPrefsKey: withIsbn ? "titles.withIsbn" : "titles.withoutIsbn", pageSize: pageSize, onPageSizeChange: changePageSize, totalCount: totalRecords, onNeedMoreData: function (offset) { return fetchMoreData(offset); }, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source, isFetching: isFetching, onRowClick: handleSelectTitle, sortBy: sort.sortBy, sortDir: sort.sortDir, onSort: handleSort, resetPaginationKey: "".concat(JSON.stringify(appliedFilters), "|").concat(sort.sortBy, "|").concat(sort.sortDir) })),
        selectedTitle && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                id: "ui-br-legaldeposits.detail.heading",
            }), onClose: handleCloseDetail, dismissible: true, actionMenu: function () { return (React.createElement(MenuSection, { label: formatMessage({
                    id: "ui-br-legaldeposits.action.menu.label",
                }), id: "actions-menu" }, readOnlyHere ? (React.createElement(React.Fragment, null,
                React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: openTakeOver, "data-test-id": "title-action-take-over" }, takeOverButton),
                selectedTitle.id && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: handleOpenAgendaOverview, "data-test-id": "title-action-agenda-dialog" },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.action.openDialog" }))))) : (React.createElement(React.Fragment, null,
                depositRecords.some(function (r) { return r.status === "OVERDUE"; }) && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () {
                        var overdueIds = new Set(depositRecords
                            .filter(function (r) { return r.status === "OVERDUE"; })
                            .map(function (r) { return r.id; }));
                        setSelectedForUrgence(overdueIds);
                        openBulkUrgence("single-title");
                    } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.detail.actions.sendEnforcement" }))),
                depositRecords.some(function (r) { return r.status === "OVERDUE"; }) && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () {
                        var overdueIds = new Set(depositRecords
                            .filter(function (r) { return r.status === "OVERDUE"; })
                            .map(function (r) { return r.id; }));
                        setSelectedForUrgence(overdueIds);
                        openBulkUrgence("single-title-reminder");
                    } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.detail.actions.sendReminder" }))),
                depositRecords.some(function (r) {
                    return r.status === "DAMAGED" || r.status === "DAMAGED_REPORTED";
                }) && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () {
                        var damagedIds = new Set(depositRecords
                            .filter(function (r) {
                            return r.status === "DAMAGED" ||
                                r.status === "DAMAGED_REPORTED";
                        })
                            .map(function (r) { return r.id; }));
                        setSelectedForUrgence(damagedIds);
                        openBulkUrgence("damaged-claim");
                    } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.detail.actions.sendDamagedClaim" }))),
                depositRecords.some(function (r) {
                    return r.status !== "RECEIVED" &&
                        r.status !== "RECEIVED_AFTER_ENFORCEMENT" &&
                        r.status !== "EXCLUDED";
                }) && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () { return setShowExcludeDialog(true); } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.enforcement.action.exclude" }))),
                depositRecords.some(function (r) { return r.status === "EXCLUDED"; }) && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () { return setShowReinstateDialog(true); } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.enforcement.action.reinstate" }))),
                canRequestCopies && !isIssueRow && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () { return openBulkUrgence("request-copy"); } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.detail.actions.requestCopy" }))),
                React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () { return setShowExtraCopyDialog(true); } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.detail.actions.addExtraCopy" })),
                selectedTitleCanRecordPreLitigation && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () { return setShowPreLitigationDialog(true); } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.preLitigation.action.record" }))),
                React.createElement("hr", null),
                selectedTitle.id && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: handleOpenAgendaOverview, "data-test-id": "title-action-agenda-dialog" },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.action.openDialog" }))),
                canMergeTitles && !isIssueRow && selectedTitle.id && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () {
                        var _a, _b, _c, _d;
                        return handleOpenMerge({
                            titleIds: [selectedTitle.id],
                            titleType: (_b = (_a = provisionalTitleQuery.data) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : "MONOGRAPH",
                            provisionalId: selectedTitle.provisional
                                ? selectedTitle.id
                                : undefined,
                            provisionalName: (_d = (_c = provisionalTitleQuery.data) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : selectedTitle.mainTitle,
                        });
                    }, "data-test-id": "title-action-merge" },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.action" }))),
                selectedTitle.provisional && !isIssueRow && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () { return setProvisionalEditOpen(true); } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.provisionalTitle.editAction" }))),
                React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: handleOpenLibraryNote },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.title.libraryNote.actionMenu" })),
                React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: handleOpenCrossLibrary },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.title.actions.crossLibraryHistory" })))))); } },
            React.createElement(TitleDetailPane, { key: unitKey(selectedTitle.id, selectedIssueId), title: (_k = selectedTitle.mainTitle) !== null && _k !== void 0 ? _k : "", issueRow: isIssueRow ? selectedTitle : undefined, agendaRow: selectedTitle, readOnly: readOnlyHere, subtitle: detailSubtitle, depositRecords: depositRecords, isLoading: isDepositRecordsLoading, expandedRecordIds: expandedEnforcementRecordIds, onToggleRecord: toggleEnforcementRecord, onReceive: function (id) { return receiveMutation.mutate(id); }, onReportDamaged: function (id) { return damagedMutation.mutate(id); }, onStatusChanged: invalidateDepositRecords, onOpenMerge: canMergeTitles && !isIssueRow && !readOnlyHere
                    ? handleOpenMerge
                    : undefined, titleId: selectedTitle.id, titleInfo: titleInfo }))),
        React.createElement(SendEnforcementDialog, __assign({ open: showSendDialog, onClose: function () {
                setShowSendDialog(false);
                setBulkUrgenceMode(null);
                setSendRecordIds(null);
            }, onSubmit: function (data) {
                return urgenceMutation.mutate({
                    formData: data,
                    depositRecordIds: sendRecordIds !== null && sendRecordIds !== void 0 ? sendRecordIds : selectedForUrgenceSorted,
                    publisherId: filters.publisherId,
                });
            }, preview: urgencePreview !== null && urgencePreview !== void 0 ? urgencePreview : null, isLoading: urgenceMutation.isLoading || urgencePreviewFetching }, (selectionKind
            ? {
                phase: sendPhase,
                onBack: function () { return setSendRecordIds(null); },
                selection: {
                    kind: selectionKind,
                    titles: (_l = urgencePreview === null || urgencePreview === void 0 ? void 0 : urgencePreview.titles) !== null && _l !== void 0 ? _l : [],
                    skipped: (_m = urgencePreview === null || urgencePreview === void 0 ? void 0 : urgencePreview.skipped) !== null && _m !== void 0 ? _m : [],
                    onContinue: setSendRecordIds,
                },
            }
            : {}), (bulkUrgenceMode === "single-title-reminder" ||
            bulkUrgenceMode === "bulk-reminder"
            ? {
                dialogTitleId: "ui-br-legaldeposits.enforcement.send.reminder.title",
                submitEmailLabelId: "ui-br-legaldeposits.enforcement.send.reminder.submit",
                submitNoteLabelId: "ui-br-legaldeposits.enforcement.send.reminder.record",
            }
            : bulkUrgenceMode === "damaged-claim" ||
                bulkUrgenceMode === "bulk-damaged-claim"
                ? {
                    dialogTitleId: "ui-br-legaldeposits.enforcement.send.damagedClaim.title",
                    submitEmailLabelId: "ui-br-legaldeposits.enforcement.send.damagedClaim.submit",
                    submitNoteLabelId: "ui-br-legaldeposits.enforcement.send.damagedClaim.record",
                }
                : bulkUrgenceMode === "request-copy" ||
                    bulkUrgenceMode === "bulk-request-copy"
                    ? {
                        dialogTitleId: "ui-br-legaldeposits.enforcement.send.requestCopy.title",
                        submitEmailLabelId: "ui-br-legaldeposits.enforcement.send.requestCopy.submit",
                        submitNoteLabelId: "ui-br-legaldeposits.enforcement.send.requestCopy.record",
                    }
                    : {}))),
        React.createElement(AddExtraCopyDialog, { open: showExtraCopyDialog, onClose: closeExtraCopyDialog, onSubmit: handleAddExtraCopy, isLoading: addExtraCopyMutation.isLoading, errorMessage: extraCopyErrorMessage }),
        React.createElement(ExcludeDialog, { open: showExcludeDialog, onClose: function () {
                setShowExcludeDialog(false);
                setBulkUrgenceMode(null);
            }, onSubmit: function (reason, note) { return excludeMutation.mutate({ reason: reason, note: note }); }, isLoading: excludeMutation.isLoading, depositRecords: bulkUrgenceMode === "bulk-exclude" ? [] : depositRecords, titleCount: bulkUrgenceMode === "bulk-exclude"
                ? selection.selectedCount
                : undefined, noApplicableTitles: bulkUrgenceMode === "bulk-exclude" &&
                excludePreview != null &&
                excludePreview.titleCount === 0, skippedNotice: bulkUrgenceMode === "bulk-exclude" ? (React.createElement(SkippedHandledElsewhere, { count: excludePreview === null || excludePreview === void 0 ? void 0 : excludePreview.skippedHandledElsewhere, listedIn: "MONOGRAPHS" })) : null }),
        React.createElement(ReinstateDialog, { open: showReinstateDialog, onClose: closeReinstateDialog, onConfirm: handleReinstate, isLoading: reinstateMutation.isLoading, errorMessage: reinstateErrorMessage, titleName: selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.mainTitle }),
        selectedTitle && (React.createElement(CrossLibraryHistoryModal, { titleId: selectedTitle.id, titleName: (_o = selectedTitle.mainTitle) !== null && _o !== void 0 ? _o : "", open: crossLibraryOpen, onClose: handleCloseCrossLibrary })),
        selectedTitle && (React.createElement(LibraryNoteDialog, { open: libraryNoteDialogOpen, titleId: selectedTitle.id, titleName: (_p = selectedTitle.mainTitle) !== null && _p !== void 0 ? _p : "", onClose: handleCloseLibraryNote })),
        (selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.provisional) && (React.createElement(ProvisionalTitleModal, { open: provisionalEditOpen, onClose: function () { return setProvisionalEditOpen(false); }, titleId: selectedTitle.id, initialValues: provisionalEditInitialValues })),
        React.createElement(PreLitigationDialog, { open: showPreLitigationDialog, onClose: function () { return setShowPreLitigationDialog(false); }, titleId: (_q = selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id) !== null && _q !== void 0 ? _q : null }),
        React.createElement(AgencyTitleConfirmDialog, { open: agencyConfirm != null, agencyTitle: (_r = agencyConfirm === null || agencyConfirm === void 0 ? void 0 : agencyConfirm.agencyTitle) !== null && _r !== void 0 ? _r : null, onConfirm: handleAgencyConfirm, onReject: handleAgencyReject, onClose: handleAgencyClose, isLoading: confirmAgencyMutation.isLoading }),
        React.createElement(PendingVerificationDialog, { open: pendingVerification != null, isbn: (_s = pendingVerification === null || pendingVerification === void 0 ? void 0 : pendingVerification.isbn) !== null && _s !== void 0 ? _s : null, pendingTitle: (_t = pendingVerification === null || pendingVerification === void 0 ? void 0 : pendingVerification.pendingTitle) !== null && _t !== void 0 ? _t : null, onOpenVerification: handlePendingVerificationOpen, onClose: handlePendingVerificationClose }),
        React.createElement(ProvisionalTitleModal, { open: provisionalScanIsbn != null || provisionalCreateOpen, onClose: handleProvisionalCreateClose, initialValues: provisionalScanInitialValues, showNotifyAgency: true, disableIsbn: provisionalCreateOpen }),
        React.createElement(ScanDuplicateTitlesDialog, { open: scanDuplicates != null, isbn: (_u = scanDuplicates === null || scanDuplicates === void 0 ? void 0 : scanDuplicates.isbn) !== null && _u !== void 0 ? _u : null, duplicateTitles: (_v = scanDuplicates === null || scanDuplicates === void 0 ? void 0 : scanDuplicates.titles) !== null && _v !== void 0 ? _v : [], isLoading: scanReceiveMutation.isLoading, onReceive: function (titleId) {
                return scanReceiveMutation.mutate({
                    isbn: scanDuplicates.isbn,
                    titleId: titleId,
                });
            }, onReceiveAsExtraCopy: handleScanReceiveAsExtraCopy, onMergeAll: handleScanMergeAll, onClose: function () { return setScanDuplicates(null); } }),
        React.createElement(AddExtraCopyDialog, { open: extraCopyScan != null, onClose: function () {
                if (!receiveExtraCopyMutation.isLoading)
                    setExtraCopyScan(null);
            }, onSubmit: function (reason, note) {
                return extraCopyScan &&
                    receiveExtraCopyMutation.mutate({
                        isbn: extraCopyScan.isbn,
                        titleId: extraCopyScan.titleId,
                        reason: reason,
                        note: note,
                    });
            }, isLoading: receiveExtraCopyMutation.isLoading, label: formatMessage({ id: "ui-br-legaldeposits.enforcement.extraCopy.receiveTitle" }, {
                title: (_w = extraCopyScan === null || extraCopyScan === void 0 ? void 0 : extraCopyScan.titleName) !== null && _w !== void 0 ? _w : "",
                isbn: (_x = extraCopyScan === null || extraCopyScan === void 0 ? void 0 : extraCopyScan.isbn) !== null && _x !== void 0 ? _x : "",
            }), confirmLabel: formatMessage({
                id: "ui-br-legaldeposits.enforcement.extraCopy.receiveConfirm",
            }) }),
        React.createElement(TitleAgendaDialog, { open: agendaOverviewOpen && !!(selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id), titleId: selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id, name: isIssueRow ? ((_y = selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.mainTitle) !== null && _y !== void 0 ? _y : detailName) : detailName, onClose: handleCloseAgendaOverview, actions: readOnlyHere ? (React.createElement(Button, { marginBottom0: true, onClick: openTakeOver, "data-test-id": "title-action-take-over-dialog" }, takeOverButton)) : (React.createElement(React.Fragment, null,
                canChangeIssueAgenda && issueAgendaQuery.data && (React.createElement(Button, { marginBottom0: true, onClick: function () { return setAgendaDialogMode("issue"); }, "data-test-id": "title-action-issue-agenda" },
                    React.createElement(FormattedMessage, { id: issueAgendaQuery.data.agenda === "MONOGRAPHS"
                            ? "ui-br-legaldeposits.agenda.action.issueToPeriodicals"
                            : "ui-br-legaldeposits.agenda.action.issueToMonographs" }))),
                titleAgendaQuery.data && (React.createElement(Button, { marginBottom0: true, onClick: function () { return setAgendaDialogMode("library"); }, "data-test-id": "title-action-agenda" },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.action.".concat(isIssueRow ? "wholePeriodical." : "").concat(titleAgendaQuery.data.agenda === "MONOGRAPHS"
                            ? "toPeriodicals"
                            : "toMonographs"), values: { name: (_z = selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.mainTitle) !== null && _z !== void 0 ? _z : "" } }))),
                canLinkToPeriodical && (React.createElement(Button, { marginBottom0: true, onClick: handleOpenLinkPeriodical, "data-test-id": "title-action-link-periodical" },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.action.linkPeriodical" }))),
                titleAgendaQuery.data && isNationalLibrary && (React.createElement(Button, { marginBottom0: true, onClick: function () { return setAgendaDialogMode("global"); }, "data-test-id": "title-action-global-type" },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.action.fixGlobalType" }))))) }),
        React.createElement(ChangeAgendaDialog, { open: agendaDialogMode !== null, mode: agendaDialogMode !== null && agendaDialogMode !== void 0 ? agendaDialogMode : "library", name: isIssueRow && agendaDialogMode !== "issue"
                ? ((_0 = selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.mainTitle) !== null && _0 !== void 0 ? _0 : detailName)
                : detailName, titleAgenda: (_1 = titleAgendaQuery.data) !== null && _1 !== void 0 ? _1 : null, issueAgenda: (_2 = issueAgendaQuery.data) !== null && _2 !== void 0 ? _2 : null, wholePeriodicalFromIssue: isIssueRow, onClose: handleCloseAgendaDialog, onChanged: handleAgendaChanged }),
        (selectedTitle === null || selectedTitle === void 0 ? void 0 : selectedTitle.id) && (React.createElement(LinkToPeriodicalDialog, { open: linkPeriodicalOpen, monographTitleId: selectedTitle.id, monographName: detailName, onClose: handleCloseLinkPeriodical, onChanged: handleLinkedToPeriodical })),
        React.createElement(TitleMergeDialogs, { request: mergeRequest, onClose: function () {
                setMergeRequest(null);
                setMergeFromScanIsbn(null);
            }, onMerged: handleMerged, onProvisionalMerged: handleCloseSelectedTitle })));
};
